import { EntityReference, EntityReferenceSchema, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CurrencyConversionProviderType } from './currency-conversion.provider-type.enum';
import { CurrencyConversionStatus } from './currency-conversion.status.enum';

export const CurrencyConversionSchema = WithBaseEntitySchema(
    z.object({
        rate: z.number().optional(),
        providerRate: z.number().optional(),
        from: EnumSchema(Currency),
        to: EnumSchema(Currency),
        amount: z.number().optional(),
        convertedAmount: z.number().optional(),
        status: EnumSchema(CurrencyConversionStatus),
        providerId: z.string().optional(),
        provider: EnumSchema(CurrencyConversionProviderType),
        quote: z.string().optional(),
        entities: z.array(EntityReferenceSchema),
        feeDefinition: z.string().optional(),
    }),
).strict();

export class CurrencyConversion extends FromSchema(CurrencyConversionSchema) implements BaseEntity {
    id: string;
    rate?: number;
    providerRate?: number;
    from: Currency;
    to: Currency;
    amount?: number;
    convertedAmount?: number;
    status: CurrencyConversionStatus;
    providerId?: string;
    provider: CurrencyConversionProviderType;
    quote?: string;
    entities?: EntityReference[];
    feeDefinition?: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
